$(document).ready(function() {
    let intervalQr = null;
    let intervalPoll = null;
    let intervalInvalidHash = null;
    let modal = $('#qr-setup-modal');
    let hash = null;
    let step = 1;

    // on opening of modal #qr-setup-modal
    modal.on('show.bs.modal', function (e) {
        if (step === null) {
            step = 1;
        }
        if (step === 1) {
            clearPins();
            screenExpired(false);
            screenStep1(true);
            screenStep2(false);
            screenStep3(false);

            generate();
            intervalQr = setInterval(generate, 1000 * 60  * 1.5);
            intervalPoll = setInterval(poll, 1000);
        } else if (step === 2) {
            screenExpired(false);
            screenStep1(false);
            screenStep2(true);
            screenStep3(false);

            intervalInvalidHash = setInterval(pollInvalidHash, 1000);
        } else if (step === 3) {
            clearPins();
            screenExpired(false);
            screenStep1(false);
            screenStep2(false);
            screenStep3(true);
        }
    });

    // on closing of modal #qr-setup-modal stop generating qr code
    modal.on('hide.bs.modal', function (e) {
        clearInterval(intervalQr);
        clearInterval(intervalPoll);
        clearInterval(intervalInvalidHash);
    });

    // on click .refresh-qr button, go back to step 1
    $('.reset-qr').on('click', function () {
        step = 1;

        screenExpired(false);
        clearPins();
        screenStep1(true);
        screenStep2(false);
        screenStep3(false);

        clearInterval(intervalQr);
        clearInterval(intervalPoll);
        clearInterval(intervalInvalidHash);

        generate();
        intervalQr = setInterval(generate, 1000 * 60  * 1.5);
        intervalPoll = setInterval(poll, 1000);
    });

    // on click .submit-pin button, submit all pin inputs
    $('.submit-pin').on('click', function () {
        let route = $(this).data('submit-pin-route');
        let pin = '';

        $('.pin-input').each(function () {
            pin += $(this).val();
        });

        // if pin is not 4 digits, return with error
        if (pin.length !== 4) {
            // add red test above input fields
            $('.pin-input').addClass('error');
        }

        $.ajax({
            url: route,
            type: 'POST',
            data: {
                pin: pin,
                hash: hash,
            },
            success: function (response) {
                if (response.data.is_valid) {
                    step = 3;

                    screenExpired(false);
                    screenStep1(false);
                    screenStep2(false);
                    screenStep3(true);
                } else {
                    $('.pin-input').addClass('error');
                    $('.pin-input').val('');
                    // show .invalid-pincode-text-block with animation, fade out after 5 seconds
                    $('.invalid-pincode-text-block').removeClass('d-none');
                    setTimeout(function () {
                        $('.invalid-pincode-text-block').addClass('d-none');
                        $('.pin-input').removeClass('error');
                    }, 5000);
                }
            },
            error: function (response) {
                $('.pin-input').addClass('error');
            }
        });
    });

    function generate() {
        let route = modal.data('generate-qr-route');

        $.ajax({
            url: route,
            type: 'GET',
            success: function (response) {
                $('#qr-code').attr('src', response.data.qr);
                hash = response.data.hash;
            },
        });
    }

    function poll() {
        let route = modal.data('polling-hash-route');

        $.ajax({
            url: route,
            type: 'POST',
            data: {
                hash: hash,
            },
            success: function (response) {
                if (response.data.is_valid) {
                    clearInterval(intervalPoll);
                    step = 2;

                    screenExpired(false);
                    screenStep1(false);
                    screenStep2(true);
                    screenStep3(false);

                    intervalInvalidHash = setInterval(pollInvalidHash, 1000);
                }
            },
        });
    }

    function pollInvalidHash() {
        let route = modal.data('polling-hash-route');

        $.ajax({
            url: route,
            type: 'POST',
            data: {
                hash: hash,
            },
            success: function (response) {
                if (!response.data.is_valid) {
                    clearInterval(intervalInvalidHash);
                    step = null;

                    clearPins();
                    screenExpired(true);
                    screenStep1(false);
                    screenStep2(false);
                    screenStep3(false);
                }
            },
        });
    }

    function screenExpired(show) {
        if (!show) {
            if ($('.expired-qr-container').hasClass('d-none') === false) {
                $('.expired-qr-container').addClass('d-none');
            }
        } else {
            if ($('.expired-qr-container').hasClass('d-none') === true) {
                $('.expired-qr-container').removeClass('d-none');
            }
        }
    }

    function screenStep1(show) {
        if (!show) {
            if ($('#qr-code').hasClass('d-none') === false) {
                $('#qr-code').addClass('d-none');
            }
            if ($('.step-1').hasClass('d-none') === false) {
                $('.step-1').addClass('d-none');
            }
        } else {
            if ($('#qr-code').hasClass('d-none') === true) {
                $('#qr-code').removeClass('d-none');
            }
            if ($('.step-1').hasClass('d-none') === true) {
                $('.step-1').removeClass('d-none');
            }
        }
    }

    function screenStep2(show) {
        if (!show) {
            if ($('.qr-pin-container').hasClass('d-none') === false) {
                $('.qr-pin-container').addClass('d-none');
            }
            if ($('.step-2').hasClass('d-none') === false) {
                $('.step-2').addClass('d-none');
            }
        } else {
            if ($('.qr-pin-container').hasClass('d-none') === true) {
                $('.qr-pin-container').removeClass('d-none');
            }
            if ($('.step-2').hasClass('d-none') === true) {
                $('.step-2').removeClass('d-none');
            }
        }
    }

    function screenStep3(show) {
        if (!show) {
            if ($('.pin-success-container').hasClass('d-none') === false) {
                $('.pin-success-container').addClass('d-none');
            }
            if ($('.step-3').hasClass('d-none') === false) {
                $('.step-3').addClass('d-none');
            }
        } else {
            if ($('.pin-success-container').hasClass('d-none') === true) {
                $('.pin-success-container').removeClass('d-none');
            }
            if ($('.step-3').hasClass('d-none') === true) {
                $('.step-3').removeClass('d-none');
            }
        }
    }

    function clearPins() {
        $('.pin-input').each(function () {
            $(this).val('');
        });
    }
});

